import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/core/services';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import { VisitorManagementService } from '../visitor-management.service';
import { FileDoc, FileUploadService } from 'src/app/core/components';
import { GLOBAL } from 'src/app/app.globals';
import { LogHelperService } from 'src/app/core/services/log-helper.service';
import { ApiCallService } from 'src/app/service/api-call.service';
import { DataShareService } from 'src/app/service/data-share.service';

let fileToReturn: File;
@Component({
  selector: 'app-request-visitor-visitor-form-modal',
  templateUrl: './request-visitor-form-modal.component.html',
  styleUrls: ['./request-visitor-form-modal.component.css']
})
export class RequestVisitorFormModalComponent implements OnInit {
  @ViewChild('tempRef1') public tempRef1: any;
  @ViewChild('tempRefApproval') public tempRefApproval: any;
  @ViewChild('uploadDocumentTemplateRef') public uploadDocumentTemplateRef: any;
  @ViewChild('takephoto') public takephoto: any;
  @ViewChild('registerface') public registerface: any;

  userId = localStorage.getItem('UserID');
  otp: any;

  createFormGroup(fields: string[], requiredFields: string[] = []): FormGroup {
    const group: any = {};
    fields.forEach(field => {
      group[field] = new FormControl(null, requiredFields.includes(field) ? Validators.required : null);
    });
    return new FormGroup(group);
  }

  // Only fields that are actually used in the HTML
  visitorForm = this.createFormGroup([
    "Company_Code", "Plant_Code", "Unit_Code", "Department_Code", "yourcompany", "name",
    "mobileno", "pgender", "emailid", "otp", "assignedHost",
    "TypeOfIdentityMasterItem_Code", "addharNo", "drvingLicense", "electionCard",
    "date", "starttime",
    "mobileallowed", "laptopallowed"
  ], [
    "yourcompany", "name", "mobileno", "emailid"
  ]);

  employeeDetailForm = this.createFormGroup(["searchedKeyword"]);
  approvalForm = this.createFormGroup(["statusMasterItem_Code", "acceptingorrejectingremark", "instructiontoreception", "allwedlaptop", "allwedmobile"]);
  docForm = new FormGroup({});

  public datePickerPickerMode: string;
  public datePickerPlaceHolder: string;
  public companyData: any[] = [];
  public plants: any[] = [];
  public units: any[] = [];
  genderTypes: any;
  identityTypes: any[] = [];
  show = false;
  showdrivinglicence = false;
  showelectioncard = false;
  photopath: any;
  uploadedFiles: FileDoc[] = [];
  public modalRef: any;
  croppedImage: any = '';
  showCropper = false;
  printBtn = false;
  documentTypes: any;
  files: any;
  
  // Properties needed for approval template
  selectedRowData: any[] = [];
  documents: any[] = [];
  visitorCode: any;
  employee_Code: any;
  
  // Properties needed for employee selection template
  allEmployeeData: any[] = [];
  optionsChecked: any[] = [];
  
  // Properties needed for face recognition
  trainedData: any[] = [];
  label: string = '';
  system: string = '';

  constructor(
    private sharedService: SharedService,
    public sharedDataService: SharedDataService,
    private modalService: NgbModal,
    private dataShareService: DataShareService,
    private cdRef: ChangeDetectorRef,
    private service: VisitorManagementService,
    private fileUploadService: FileUploadService,
    private logHelperService: LogHelperService,
    public activeModal: NgbActiveModal,
    public apiCall: ApiCallService
  ) {
    this.datePickerPlaceHolder = this.sharedService.datePickerSettings.placeHolder;
    this.datePickerPickerMode = this.sharedService.datePickerSettings.pickerMode;
    this.getDocumentTypes();
  }

  ngOnInit() {
    this.files = [];
    this.getCompanyData();
    this.getPlants();
    this.getUnits();
    this.getVisitorCategory();
    this.identityProof();
    this.employeeDetail();
    this.genderTypes = this.dataShareService.masterDataArrayDataShareService.filter(list => list.Parent_Code === 302);
    
    if (!this.genderTypes || this.genderTypes.length === 0) {
      this.genderTypes = [
        { MasterItem_Code: 319, Name: 'Male' },
        { MasterItem_Code: 320, Name: 'Female' },
        { MasterItem_Code: 321, Name: 'Other' }
      ];
    }
  }

  getDocumentTypes() {
    this.apiCall.getDocumentTypes().subscribe((res: any) => {
      this.documentTypes = res.Data;
    });
  }

  closeModal() {
    this.activeModal.dismiss('close');
  }

  getCompanyData() {
    return this.service.getCompanyMasterData().subscribe((response: any) => {
      this.companyData = response;
      if (this.companyData.length === 1) {
        this.visitorForm.controls['Company_Code'].setValue(this.companyData[0].Company_Code);
      }
    });
  }

  getPlants() {
    return this.service.getPlantMasterData().subscribe((response: any) => {
      this.plants = response;
      if (this.plants.length === 1) {
        this.visitorForm.controls['Plant_Code'].setValue(this.plants[0].Plant_Code);
      }
    });
  }

  getUnits() {
    return this.service.getUnitMasterData(this.visitorForm.controls['Plant_Code'].value || 100).subscribe((res: any) => {
      this.units = res.Data.Table;
      if (this.units.length === 1) {
        this.visitorForm.controls['Unit_Code'].setValue(this.units[0].Unit_Code);
      }
    });
  }

  getVisitorCategory() {
    const reqObj: any = {
      ShortCode: null,
      Search: null,
      Parent_Code: 1065,
      Page_Code: 424,
      RequireType: 2,
      ActionType: 0,
      UserId: this.userId
    };
    this.service.visitorCategorys(reqObj).subscribe((response: any) => {
      // visitorcategory not used in HTML, but keeping for potential future use
    });
  }

  identityProof() {
    const reqObj: any = {
      ShortCode: null,
      Search: null,
      Parent_Code: 575,
      Page_Code: 424,
      RequireType: 2,
      ActionType: 0,
      UserId: this.userId
    };
    this.service.getIdentityProof(reqObj).subscribe((response: any) => {
      this.identityTypes = response;
    });
  }

  changeIdentitytype() {
    const typeValue = this.visitorForm.controls['TypeOfIdentityMasterItem_Code'].value;
    if (typeValue === 576) { // Aadhar Card
      this.show = true;
      this.showdrivinglicence = false;
      this.showelectioncard = false;
    } else if (typeValue === 577) { // Driving License
      this.showdrivinglicence = true;
      this.show = false;
      this.showelectioncard = false;
    } else if (typeValue === 578) { // Election Card
      this.showelectioncard = true;
      this.showdrivinglicence = false;
      this.show = false;
    }
  }

  public onvisitordetail(): void {
    this.clearData();
    this.activeModal.dismiss('close');
  }

  private clearData() {
    this.visitorForm.reset();
    this.employeeDetailForm.reset();
    this.approvalForm.reset();
    this.show = false;
    this.showdrivinglicence = false;
    this.showelectioncard = false;
  }

  private formatDate(dateValue: any): string {
    if (!dateValue) return null;
    if (typeof dateValue === 'string') return dateValue;
    if (dateValue._isAMomentObject) {
      return dateValue.format('YYYY-MM-DD');
    }
    return new Date(dateValue).toISOString().split('T')[0];
  }

  private formatTime(timeValue: any): string {
    if (!timeValue) return null;
    if (typeof timeValue === 'string') return timeValue;
    if (timeValue._isAMomentObject) {
      return timeValue.format('HH:mm:ss');
    }
    return new Date(timeValue).toTimeString().split(' ')[0];
  }

  public SubmitRequest(): void {
    Object.keys(this.visitorForm.controls).forEach(key => {
      this.visitorForm.get(key).markAsTouched();
    });
    
    if (this.visitorForm.invalid) {
      const invalidFields = [];
      Object.keys(this.visitorForm.controls).forEach(key => {
        if (this.visitorForm.get(key).invalid) {
          invalidFields.push(key);
        }
      });
      this.logHelperService.logError({
        message: 'Please fill all required fields: ' + invalidFields.join(', ')
      });
      return;
    }
  
    const value = this.visitorForm.getRawValue();

    // Get RequestLevel_Code from visitor listing
    let reqObj = {
      Visitor_Code: null,
      selectedField: null,
      Search: null,
      RequireType: 2,
      ActionType: 0,
      UserId: this.userId
    };

    this.apiCall.getAllVisitor(reqObj).subscribe((visitorRes: any) => {
      let requestLevelCode = 368; // default
      let allRequestLevelCodes = [];
      
      // Get all RequestLevel_Codes from visitor's ApprovalInfo
      if (visitorRes && Array.isArray(visitorRes) && visitorRes.length > 0) {
        const firstVisitor = visitorRes[0];
        if (firstVisitor.ApprovalInfo) {
          try {
            const approvalInfo = JSON.parse(firstVisitor.ApprovalInfo);
            allRequestLevelCodes = approvalInfo.map(item => item.RequestLevel_Code).filter(code => code !== 0);
            if (allRequestLevelCodes.length > 0) {
              requestLevelCode = allRequestLevelCodes[allRequestLevelCodes.length - 1];
            }
          } catch (error) {
            console.error('Error parsing ApprovalInfo:', error);
          }
        }
      }

      const createReqObj = {
        "FA3AE3BB-807F-4592-85E7-103F00D17853": [
          {
            Visitor_Code: null,
            Company_Code: value.Company_Code || 101,
            Plant_Code: value.Plant_Code || 100,
            Unit_Code: value.Unit_Code || null,
            Department_Code: value.Department_Code || null,
            EntryFormStatus: 0,
            VisitorCompany: value.yourcompany,
            FullName: value.name,
            GenderMAsterItem_Code: value.pgender || 319,
            JobTitle: value.jobtitle || null,
            MobileNo: value.mobileno,
            SmsOTP: value.otp || null,
            EmailID: value.emailid,
            EmailOTP: null,
            EmergancyContactName: null,
            EmergancyContactNo: null,
            Address1: null,
            Address2: null,
            ZipCode: null,
            Country_Code: null,
            State_Code: null,
            District_Code: null,
            City_Code: null,
            PostOffice_Code: null,
            Village_Code: null,
            VisitorCategoryMIL_Code: null,
            IDProofTypeMIL_Code: value.TypeOfIdentityMasterItem_Code || null,
            AddharNo: value.addharNo || null,
            PassportNo: null,
            ElectionCardNo: value.electionCard || null,
            DrivingLicenceNo: value.drvingLicense || null,
            StartDate: this.formatDate(value.date),
            StartTime: value.starttime || null,
            Temperature: null,
            TokenNumber: null,
            LockerNumber: null,
            VisitorPurposeTypeMIL_Code: null,
            Visitorpurpose: null,
            HaveMobile: value.mobileallowed ? 1 : 0,
            HaveToolkit: null,
            HaveLaptop: value.laptopallowed ? 1 : 0,
            HaveMaterials: null,
            HaveReturnableMaterials: null,
            HaveMatchBox: null,
            AllowedLaptop: value.laptopallowed ? 1 : 0,
            AllowedMobile: value.mobileallowed ? 1 : 0,
            AllowedToolkit: null,
            AllowedMaterials: null,
            AllowedReturnableMaterials: null,
            IsBlacklisted: null,
            ReasonForBlacklist: null,
            Remark: null,
            Instruction: null,
            CreatedBy: this.userId,
            ModifiedBy: this.userId,
            "0BF55340-7B38-4378-BC0D-73AD9CA06384": [
              {
                Request_Code: null,
                Visitor_Code: null,
                Host_Code: this.userId,
                Plant_Code: value.Plant_Code || 100,
                RequestType_Code: 111,
                RequestNo: null,
                FirstRequestUser: this.userId,
                IsApproved: 0,
                CreatedBy: this.userId,
                ModifiedBy: this.userId,
                "3D867CB0-029A-4EF8-A71B-0E58CF686196": [
                  {
                    RequestApprover_Code: null,
                    Request_Code: null,
                    RequestLevel_Code: requestLevelCode,
                    StatusMasterList_Code: 555,
                    Comment: null,
                    AssignedUserId: value.assignedHost || this.userId,
                    CreatedBy: this.userId,
                    ModifiedBy: this.userId 
                  }
                ]
              }
            ]
          }
        ]
      };

      this.service.createVisitor(createReqObj).subscribe(
        (response: any) => {
          let visitorCode = null;
          
          if (response && response['FA3AE3BB-807F-4592-85E7-103F00D17853']) {
            const visitorArray = response['FA3AE3BB-807F-4592-85E7-103F00D17853'];
            if (Array.isArray(visitorArray) && visitorArray.length > 0) {
              visitorCode = visitorArray[0].Visitor_Code;
            }
          }
          
          this.service.getRequestStageLevelPriority(111, parseInt(this.userId), value.Plant_Code || 100)
            .subscribe((levelResponse: any) => {
              let isApproved = false;
              if (levelResponse && levelResponse.length > 0) {
                const plantData = levelResponse[0].Values;
                
                if (plantData && plantData.length > 0) {
                  const levels = plantData[0].Values;
                  
                  const matchedLevel = levels.find(level => 
                    allRequestLevelCodes.includes(level.RequestLevel_Code) && level.IsLastLevel === true
                  );
                  
                  if (matchedLevel) {
                    isApproved = true;
                  }
                }
              }
            });
          
          if (visitorCode) {
            this.uploadDocuments(visitorCode);
            if (this.photopath) {
              this.fileUploadService.uploadPhoto(this.photopath, { Visitor_Code: visitorCode }, GLOBAL.APIS.VISITOR_MANAGEMENT.UPLOAD_VISITOR_PHOTO)
                .subscribe((res) => {
                }, (photoError) => {
                });
            }
            
            // Send email to visitor
            if (value.emailid) {
              const visitorLink = `${window.location.origin}/visitor-management/after-pre-request/${visitorCode}`;
              const emailPayload = {
                To: value.emailid,
                CC: null,
                BCC: null,
                Subject: 'Your Visitor Pass Request is Approved',
                Body: `<p>Dear ${value.name || 'Visitor'},</p>
                       <p>Greetings.</p>
                       <p>Your visitor request has been approved. To complete the entry process, kindly fill in the remaining required information and submit your details using the link provided below:</p>
                       <p><a href="${visitorLink}">${visitorLink}</a></p>
                       <p>Please ensure that all details are submitted before your visit date to avoid any delays during entry.</p>
                       <p>If you face any issues or need assistance, feel free to contact us.</p>
                       <p>We look forward to welcoming you.</p>
                       <p>Best Regards,<br/>${value.yourcompany || 'Company'}</p>`
              };
              
              this.apiCall.sendEmail(emailPayload).subscribe(
                (emailRes) => {
                  this.logHelperService.logSuccess({
                    message: 'Email sent to visitor successfully'
                  });
                },
                (emailError) => {
                  console.error('Email sending failed:', emailError);
                  this.logHelperService.logError({
                    message: 'Failed to send email: ' + (emailError.error && emailError.error.Message ? emailError.error.Message : (emailError.message || 'Unknown error'))
                  });
                }
              );
            }
          }
          
          this.logHelperService.logSuccess({
            message: 'Visitor request submitted successfully'
          });
          this.activeModal.close('refresh');
        },
        (error) => {
          console.error('API Error:', error);
          this.logHelperService.logError({
            message: 'Error creating visitor (' + error.status + '): ' + (error.error && error.error.Message ? error.error.Message : (error.message || 'Unknown error'))
          });
        }
      );
    });
  }
  
  uploadDocuments(Visitor_Code) {
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      if (Visitor_Code) {
        this.fileUploadService.uploadFiles(
          this.uploadedFiles,
          Visitor_Code,
          GLOBAL.APIS.CONTRACTOR_MANAGEMENT.UPLOAD_LABOUR_DOC
        ).subscribe((res) => { });
      }
    }
  }

  employeeDetail() {
    return this.service.getEmployeeDetail().subscribe((res: any) => {
      this.allEmployeeData = res;
    });
  }

  Host() {
    const value = this.visitorForm.getRawValue();
    if (value.Company_Code != null && value.Plant_Code != null && value.yourcompany != null
      && value.name != null && value.emailid != null && value.date != null && value.starttime != null) {
      this.modalRef = this.modalService.open(this.tempRef1,
        { size: 'lg', backdrop: 'static', windowClass: 'modal-scrollbar-hide' });
      this.employeeDetail();
    } else {
      this.logHelperService.logError({
        message: 'Please Fill Mandatory Fields First'
      });
    }
  }


  base64ToFile(data, filename) {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  imageLoaded() {
    this.showCropper = true;
  }

  cropperReady() {}

  loadImageFailed() {}

  printRequest() {
    window.print();
  }

  onFilesChanged(newFiles: any) {
    this.files = newFiles;
    this.uploadedFiles = newFiles;
  }

  // Approval related methods
  onCloseAproval(): void {
    this.clearData();
    this.modalRef.close();
  }

  getDocuments(visitorCode: any): void {
    this.service.getDocumentForLabourVerify(visitorCode)
      .subscribe((verificationDoc: any) => {
        if (verificationDoc.Status) {
          this.documents = verificationDoc.Data;
        }
      });
  }

  public ApproveRequest(): void {
    const value = this.approvalForm.getRawValue();
    const data: any = {
      StatusMasterList_Code: 1,
      allowedMobile: value.allwedmobile,
      AllowedLabptop: value.allwedlaptop,
      Remark: value.acceptingorrejectingremark,
      Instruction: value.instructiontoreception,
      Visitor_Code: this.visitorCode,
      Employee_Code: this.employee_Code,
      CreatedBy: localStorage.getItem('UserID'),
    };
    this.service.ApproveRejectRequest(data).subscribe((response: any) => {
      if (response.Status) {
        this.logHelperService.logSuccess({
          message: 'Request Approved successfully'
        });
        this.clearData();
        this.modalRef.close();
      }
    });
  }

  public RejectRequest(): void {
    const value = this.approvalForm.getRawValue();
    const data: any = {
      StatusMasterList_Code: 2,
      allowedMobile: value.allwedmobile,
      AllowedLabptop: value.allwedlaptop,
      Remark: value.acceptingorrejectingremark,
      Instruction: value.instructiontoreception,
      Visitor_Code: this.visitorCode,
      Employee_Code: this.employee_Code,
      CreatedBy: localStorage.getItem('UserID'),
    };
    this.service.ApproveRejectRequest(data).subscribe((response: any) => {
      if (response.Status) {
        this.logHelperService.logSuccess({
          message: 'Request Rejected successfully'
        });
        this.clearData();
        this.modalRef.close();
      }
    });
  }

  public HoldRequest(): void {
    const value = this.approvalForm.getRawValue();
    const data: any = {
      StatusMasterList_Code: 3,
      allowedMobile: value.allwedmobile,
      AllowedLabptop: value.allwedlaptop,
      Remark: value.acceptingorrejectingremark,
      Instruction: value.instructiontoreception,
      Visitor_Code: this.visitorCode,
      Employee_Code: this.employee_Code,
      CreatedBy: localStorage.getItem('UserID'),
    };
    this.service.ApproveRejectRequest(data).subscribe((response: any) => {
      if (response.Status) {
        this.logHelperService.logSuccess({
          message: 'Request Put on Hold successfully'
        });
        this.clearData();
        this.modalRef.close();
      }
    });
  }

  IsCheck(item: any, event: any): void {
    if (event.target.checked) {
      if (this.optionsChecked.indexOf(item.Employee_Code) === -1) {
        this.optionsChecked.push(item.Employee_Code);
      }
    } else {
      const index = this.optionsChecked.indexOf(item.Employee_Code);
      if (index > -1) {
        this.optionsChecked.splice(index, 1);
      }
    }
  }

  getRecognizationPersonData(event: any): void {}

  getData(event: any): void {}
}
